import React from 'react';
import { connect } from 'react-redux';
import ConvenienceFeesAccordion from 'payments/views/convenience-fee/ConvenienceFeesAccordion';
import Rupee from 'views/Rupee';
import classnames from 'classnames';
import { rupees } from 'config/utils';

const CartConvenienceFee = ({
  orderAmount,
  showConvenienceFee,
  selectedPaymentMode,
  isRetrying,
}) => (
  showConvenienceFee && selectedPaymentMode ?
  <div
    className={classnames('text-medium', !isRetrying ? 'push--bottom' : 'push-half--top')}
    style={isRetrying ? { paddingBottom: '6px' } : { borderBottom: '1px solid  rgba(227, 236, 242, 0.5)', paddingBottom: '6px' }}>
    <span>Amount</span>
    <span className="right"><Rupee value={rupees(orderAmount)} /></span>
    <ConvenienceFeesAccordion />
  </div> :
  null
);

const mapStateToProps = ({
  cart,
  settings,
  retry,
}) => {
  if (settings && settings.isRetrying) {
    return {
      showConvenienceFee: settings.showConvenienceFee,
      selectedPaymentMode: retry.finalizePurchase.selectedPaymentMode,
      isRetrying: true,
      orderAmount: retry.finalizePurchase.orderAmount,
    };
  }
  return {
    showConvenienceFee: cart.settings.showConvenienceFee,
    selectedPaymentMode: cart.finalizePurchase.selectedPaymentMode,
    isRetrying: false,
    orderAmount: cart.finalizePurchase.orderAmount,
  };
};

export default connect(mapStateToProps)(CartConvenienceFee);



// WEBPACK FOOTER //
// ./src/cart/views/full/CartConvenienceFee.js